export { default as Video } from './video'



// WEBPACK FOOTER //
// ./src/core/video/index.js